// @flow
import React from 'react';
import { CLUSTER_RESOURCE_INPUTS_DETAILS_CONFIG_MAP } from '@streaming-projects/resource-definitions/cluster-resource-definitions/cluster-resource-inputs-config';
import { CLUSTER_DEDICATED_PARTITION_LIMIT_INCREASE_TOGGLE_BACKEND_NAME } from '@src/constants';
import { CheckBoxField } from '@src/formik-utils/FormFields';

export const SPDedicatedPerCKUPartitionLimitIncreaseToggleContainer = ({
  disabled = false,
  disableOnFormErrors = true,
}) => {
  const { displayName, backendFieldName, tooltip } = CLUSTER_RESOURCE_INPUTS_DETAILS_CONFIG_MAP.get(
    CLUSTER_DEDICATED_PARTITION_LIMIT_INCREASE_TOGGLE_BACKEND_NAME
  );
  return (
    <CheckBoxField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      displayCheckBoxBelowLabel={true}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      tooltip={tooltip}
    />
  );
};
